import { CookieService } from 'ngx-cookie-service';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { APP_TOKEN, AppsEnum } from '@ose/enums';
import { appRoutes } from './app.routes';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { MultiTranslateHttpLoader } from '@ose/utils';
import { ErrorInterceptor } from '@ose/services';

export function jwtOptionsFactory(cookieService: CookieService) {
  return {
    tokenGetter: () => cookieService.get('access-token')
  };
}

export function appInitializerFactory(translate: TranslateService) {
  return () => {
    translate.setDefaultLang('fa');
    const lang =  'fa';
    return translate.use(lang).toPromise();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideEnvironmentNgxMask(),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient): MultiTranslateHttpLoader => {
            return new MultiTranslateHttpLoader(http, {
              resources: [
                { prefix: '/assets/i18n/client/', suffix: '.json' }
              ],
            });
          },
          deps: [HttpClient]
        },
      })
    ),
    importProvidersFrom(
      JwtModule.forRoot({
        jwtOptionsProvider: {
          provide: JWT_OPTIONS,
          useFactory: jwtOptionsFactory,
          deps: [CookieService]
        }
      })
    ),
    { provide: 'AUTH_SCOPE', useValue: "client" },
    { provide: APP_TOKEN, useValue: AppsEnum.CLIENT },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true
    }
  ],
};
